export default "__VITE_ASSET__CtOCVlij__"